import { render } from "./LoadingProgressBar.vue?vue&type=template&id=af118068&scoped=true"
import script from "./LoadingProgressBar.vue?vue&type=script&lang=js"
export * from "./LoadingProgressBar.vue?vue&type=script&lang=js"

import "./LoadingProgressBar.vue?vue&type=style&index=0&id=af118068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af118068"]])

export default __exports__